import FooterModel from "./models/FooterModel";

const FooterStore = {
  name: 'FooterStore',
  spec: FooterModel,
  saveLocally: false,
  initialState: {
    footerBooks:[]
  },
};

const stores=[FooterStore];

export default stores;